/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Referral_Delete_Blocked_PendingInputs */



/**
* | output |
* | --- |
* | "A signup using this code is still in progress. Try again later, or deactivate it." |
*
* @param {Partner_Referral_Delete_Blocked_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_referral_delete_blocked_pending = /** @type {((inputs?: Partner_Referral_Delete_Blocked_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Referral_Delete_Blocked_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Registrierung mit diesem Code läuft noch. Bitte später erneut versuchen oder den Code deaktivieren.")
	return /** @type {LocalizedString} */ ("A signup using this code is still in progress. Try again later, or deactivate it.")
});